import { useState } from 'react';
import { TextField, Button, Paper } from '@mui/material';
import { styled } from '@mui/system';
import { TitleSimple } from "../../styles/Titles";
import { RootMargin } from '../Root';
const Root = RootMargin;

const ButtonStyled = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const Title = TitleSimple;

const AddTutorForm = () => {
  const [corrector, setCorrector] = useState({
    name: '',
    lastName: '',
    email: '',
  });

  const handleCorrectorChange = (e) => {
    setCorrector({ ...corrector, [e.target.name]: e.target.value });
  };

  const handleAddCorrectorSubmit = (e) => {
    e.preventDefault();
    alert('Nuevo corrector agregado con éxito');
    setCorrector({ name: '', lastName: '', email: '' });
  };

  return (
    <Root>
      <Title variant="h5">Agregar Corrector</Title>
      <form onSubmit={handleAddCorrectorSubmit}>
        <TextField
          label="Nombre"
          name="name"
          value={corrector.name}
          onChange={handleCorrectorChange}
          fullWidth
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          label="Apellido"
          name="lastName"
          value={corrector.lastName}
          onChange={handleCorrectorChange}
          fullWidth
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={corrector.email}
          onChange={handleCorrectorChange}
          fullWidth
          margin="normal"
          variant="outlined"
          required
        />
        <ButtonStyled variant="contained" color="primary" type="submit">
          Agregar Corrector
        </ButtonStyled>
      </form>
    </Root>
  );
};

export default AddTutorForm;